<div class="cebe-card mat-elevation-z3">
	<div
		class="cebe-card-header"
		[style.background-image]="'url(' + cebe.imageDataB64 + ')'"
		(click)="goToCebe()"
	></div>
	<div class="cebe-card-content">
		<div class="title-container">
			<div class="title-container-left">
				<div class="cebe-icon"></div>
				<div class="title-code">{{ cebe["codigo"] }}</div>
				<div class="title-name">{{ cebe["descripcion"] }}</div>
			</div>
			<div class="title-container-right">
				<mat-icon
					(click)="goToCebe()"
					class="open-icon"
					aria-hidden="false"
					aria-label="link"
					fontIcon="outbound"
				></mat-icon>
			</div>
		</div>
		<div class="actions-container">
			<div class="tags-container">
				<mat-chip-set>
					<mat-chip *ngIf="cebe.codigoIso2Pais">
						<div>
							{{
								"countries." + cebe["codigoIso2Pais"]
									| translate
							}}
						</div>
					</mat-chip>
					<mat-chip *ngIf="cebe.codigoActividad">
						<div>
							{{
								"departments." + cebe["codigoActividad"]
									| translate
							}}
						</div>
					</mat-chip>
					<mat-chip
						*ngIf="cebe.codigoTipoProyecto"
						style="display: none"
					>
						<div>
							{{
								"site.type." + cebe["codigoTipoProyecto"]
									| translate
							}}
						</div>
					</mat-chip>
				</mat-chip-set>
			</div>
			<div
				class="favourite"
				[ngClass]="cebe.isFav ? 'fav' : 'unfav'"
				(click)="toggleFav()"
			></div>
		</div>
	</div>
</div>
